import { ESimpleThemeColorNames } from '@common/libs/themes/src/variants/simple/enums/color.enum';

export const SIMPLE_THEME_COLORS_VARIABLES = {
    [ESimpleThemeColorNames.pageBackground]: '--page-background-color',
    [ESimpleThemeColorNames.contentBackground]: '--content-background-color',
    [ESimpleThemeColorNames.primary]: '--primary-color',
    [ESimpleThemeColorNames.secondary]: '--secondary-color',
    [ESimpleThemeColorNames.text]: '--text-color',
};
